import { TemplateType } from '../../Template/Template.type';

export enum EventTriggerPayloadRequestMethod {
  TAB = 'TAB',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}
export interface EventTriggerPayloadRequest {
  method: EventTriggerPayloadRequestMethod;
  url: string;
}

export enum EventTriggerPayloadFieldTypes {
  SELECT = 'select',
  INPUT = 'input',
  TEXTAREA = 'textarea',
}

export enum EventTriggerPayloadFieldPropsHookTypes {
  EMPLOYEES = 'employees',
}

export interface EventTriggerPayloadFieldProps {
  hook?: EventTriggerPayloadFieldPropsHookTypes;
  value?: any;
  additional?: any;
  isSearchable?: boolean;
  isMulti?: boolean;
  isReadonly?: boolean;
  isDisabled?: boolean;
}

export interface EventTriggerPayloadField {
  type: string;
  name: string;
  label: string;
  props?: EventTriggerPayloadFieldProps;
}

export enum EventTriggerPayloadFooterBlockType {
  LABEL = 'label',
  SUBMIT = 'submit',
  CANCEL = 'cancel',
}
export interface EventTriggerPayloadFooterBlock {
  type: EventTriggerPayloadFooterBlockType;
  label: string;
  after_close?: boolean;
}

export interface EventTriggerPayloadFooter {
  left?: EventTriggerPayloadFooterBlock[];
  right?: EventTriggerPayloadFooterBlock[];
}

export interface EventTriggerPayload {
  request?: EventTriggerPayloadRequest;
  fields?: EventTriggerPayloadField[];
  footer?: EventTriggerPayloadFooter;
  modalStyle?: any;
}

export interface EventTriggerType {
  type: string;
  template: TemplateType;
  payload?: EventTriggerPayload;
}
